"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Backbone = _interopRequireDefault(require("Backbone"));

var _LocalSettings = require("crm_data/settings/LocalSettings");

var getStorage = function getStorage(_ref) {
  var session = _ref.session;

  if (session) {
    return sessionStorage;
  }

  return localStorage;
};

var LocalSettings =
/*#__PURE__*/
function (_Backbone$Model) {
  (0, _inherits2.default)(LocalSettings, _Backbone$Model);

  function LocalSettings() {
    (0, _classCallCheck2.default)(this, LocalSettings);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LocalSettings).apply(this, arguments));
  }

  (0, _createClass2.default)(LocalSettings, [{
    key: "pollForChanges",
    value: function pollForChanges(key, interval) {
      var _this = this;

      setInterval(function () {
        _this.get(key, {
          force: true
        });
      }, interval);
    }
  }, {
    key: "get",
    value: function get(attr) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // eslint-disable-next-line
      var item = (0, _get2.default)((0, _getPrototypeOf2.default)(LocalSettings.prototype), "get", this).apply(this, arguments);

      if (!item || options.force) {
        try {
          item = (0, _LocalSettings.getFrom)(getStorage(options), attr);
        } finally {
          if (item) {
            this.set(attr, item);
          }
        }
      }

      return item;
    }
  }, {
    key: "set",
    value: function set(key, val) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var attrs = {};

      if ((0, _typeof2.default)(key) === 'object') {
        attrs = key;
        options = val || {};
      } else {
        attrs[key] = val;
      }

      try {
        var storage = getStorage(options);
        Object.keys(attrs).forEach(function (attr) {
          var value = attrs[attr];

          if (options.unset) {
            (0, _LocalSettings.deleteFrom)(storage, attr);
          } else {
            (0, _LocalSettings.setFrom)(storage, attr, value);
          }
        });
      } finally {
        // eslint-disable-next-line
        (0, _get2.default)((0, _getPrototypeOf2.default)(LocalSettings.prototype), "set", this).apply(this, arguments);
      }
    }
  }, {
    key: "unset",
    value: function unset(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      try {
        var storage = getStorage(options);
        (0, _LocalSettings.deleteFrom)(storage, key);
      } finally {
        // eslint-disable-next-line
        (0, _get2.default)((0, _getPrototypeOf2.default)(LocalSettings.prototype), "unset", this).apply(this, arguments);
      }
    }
  }]);
  return LocalSettings;
}(_Backbone.default.Model);

var settings = new LocalSettings();
var _default = settings;
exports.default = _default;
module.exports = exports.default;